import React from 'react';
import { motion } from 'framer-motion';
import './TerminalHeader.css';

function TerminalHeader() {
  return (
    <motion.div 
      className="terminal-header"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
    >
      <div className="header-line">
        <span className="header-prompt">root@cyber-terminal:~$</span>
        <span className="header-command"> ./initialize.sh</span>
      </div>
      <div className="header-line">
        <span className="header-output">[SYSTEM] КИБЕР-ТЕРМИНАЛ v2.0</span>
      </div>
      <div className="header-line">
        <span className="header-output">[SYSTEM] ДОСТУП РАЗРЕШЕН</span>
      </div>
      <div className="header-decoration">
        {Array.from({ length: 50 }).map((_, i) => (
          <span key={i}>_</span>
        ))}
      </div>
    </motion.div>
  );
}

export default TerminalHeader;